interface OpenPatientFileOptions {
  patientId: string;
  allowSingleWindow: boolean;
}

export function openPatientFile({
  patientId,
  allowSingleWindow,
}: OpenPatientFileOptions) {
  const patientFileUrl = `/patient/${patientId}`;

  if (!allowSingleWindow) {
    const patientWindow = window.open(patientFileUrl, "_blank");
    patientWindow?.focus();
    return;
  }

  const patientWindowName = `cadendar-patient-${patientId}`;
  const patientWindow = window.open("", patientWindowName);

  if (!patientWindow) {
    return;
  }

  if (patientWindow.location.pathname !== patientFileUrl) {
    patientWindow.location.replace(patientFileUrl);
  }

  patientWindow.focus();
}
